// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./controllers";
import { createIcons } from "lucide";
import {
  ArrowRight,
  Banknote,
  Building,
  Calendar,
  CalendarRange,
  Check,
  CheckCircle,
  ChevronRight,
  CreditCard,
  ExternalLink,
  GraduationCap,
  Image,
  LogOut,
  Menu,
  MoreVertical,
  Music,
  PanelLeftClose,
  Pencil,
  Receipt,
  Search,
  Shield,
  Sun,
  Tag,
  Trash2,
  Users,
  Wallet,
  X,
} from "lucide";

// Initialize Lucide icons on page load and after Turbo navigations
function initIcons() {
  createIcons({
    icons: {
      ArrowRight,
      Banknote,
      Building,
      Calendar,
      CalendarRange,
      Check,
      CheckCircle,
      ChevronRight,
      CreditCard,
      ExternalLink,
      GraduationCap,
      Image,
      LogOut,
      Menu,
      MoreVertical,
      Music,
      PanelLeftClose,
      Pencil,
      Receipt,
      Search,
      Shield,
      Sun,
      Tag,
      Trash2,
      Users,
      Wallet,
      X,
    },
  });
}

document.addEventListener("turbo:load", initIcons);
document.addEventListener("turbo:frame-load", initIcons);
